// extracted by mini-css-extract-plugin
export default {"benefitsContainer":"benefits_benefitsContainer__fE3+5","subtitle":"benefits_subtitle__1r8FM","benefits":"benefits_benefits__z9I8Y"};